
import { Typography , Button} from "antd";


interface InfoProductInterface{
    tittle?:string,
    completedDate: string | Date,
    quantity: number,
}

interface info {
    info: InfoProductInterface
}

const InfoProduct = (info:info) => {

    const { Text, Link } = Typography;

    return (
        <div style={{display:'flex',justifyContent:'space-between', alignItems:'center'}}>
            <div style={{display:'flex'}}>
            <strong>{info.info.tittle ?? "최초 입고일"} :</strong> &nbsp;{info.info.completedDate}
            </div>
            <div style={{padding:'1rem 2rem'}}>
                <Button className="renueProduct">
                    <p style={{padding:'0 0.5rem',}}>재고 수량 : &nbsp;</p>
                        {info.info.quantity ?? '0'}
                </Button>
            </div>
        </div>
    )
}

export default InfoProduct